export const MAX_CHARS = 2000;

export const CATEGORIES = [
  { id: "bug", label: "Bug Report" },
  { id: "feature", label: "Feature Request" },
  { id: "ux", label: "UX Issue" },
  { id: "performance", label: "Performance" },
  { id: "content", label: "Content Issue" },
] as const satisfies readonly { id: string; label: string }[];

export type FeedbackCategoryId = (typeof CATEGORIES)[number]["id"];

export const DEFAULT_CATEGORY: FeedbackCategoryId = "bug";

export const SUBMIT_SUCCESS_MESSAGE = "Thank you for your feedback!";

export const CLIPBOARD_EMPTY_MESSAGE = "No image found in the clipboard";

/**
 * Max attachment size in decoded bytes. Mirrors the backend image cap
 * (`DEFAULT_MAX_IMAGE_BYTES` in `backend/app/notifiers/image_attachment.py`). Oversized
 * uploads/pastes are rejected client-side so the user keeps their typed
 * feedback instead of having the whole submission bounced.
 */
export const MAX_ATTACHMENT_BYTES = 8 * 1024 * 1024;

export const ATTACHMENT_TOO_LARGE_MESSAGE =
  "That image is over 8 MB. Attach a smaller image or use Capture Screenshot.";

/**
 * Elements carrying this attribute are hidden (visibility:hidden) while the
 * native screenshot frame is grabbed, so the feedback modal/backdrop and the
 * help FAB don't appear in the capture.
 */
export const SCREENSHOT_EXCLUDE_ATTR = "data-screenshot-exclude";
